import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import s from '../../css/main/previewItem.module.css'

const PreviewItem = memo(
	({ id, title, description, date, isSevenDaysPassed }) => {
		return (
			<li className={s.tag}>
				<article>
					<Link to={`/changes#${id}`}>
						<div className={s.meta}>
							<time className={s.date}>{date}</time>
							{isSevenDaysPassed && <span className={s.new}>Новое</span>}
						</div>
						<h3>{title}</h3>
						<p className='common__text'>{description}</p>
					</Link>
				</article>
			</li>
		)
	}
)

export default PreviewItem
